import { BoardImageContext } from "~applications";
import { createStaticContextProvider, lazyValue } from "~utils";

export const BoardImageProvider = createStaticContextProvider(
  BoardImageContext,
  lazyValue(() => import("./generate-board-image")),
);
